import { createAction } from 'redux-actions'

export const setAlertTypes = createAction('ALERT_TYPES_SET')

export const setNewAlertsCount = createAction('NEW_ALERTS_COUNT_SET')

export const setAlertsPriorityCount = createAction('SET_ALERT_PRIORITY_COUNT')
export const clearAlertsPriorityCount = createAction(
  'CLEAR_ALERTS_PRIORITY_COUNT'
)

export const setIsAlertRedirectFromDashboard = createAction(
  'SET_IS_ALERT_REDIRECT_FROM_DASHBOARD'
)
export const setAlertPredefinedFilters = createAction(
  'SET_ALERT_PREDEFINED_FILTERS'
)

export const setPatientAlertList = createAction('SET_PATIENT_ALERT_LIST')
export const setAlertPatientUuid = createAction('SET_ALERT_PATIENT_UUID')

export const resetAlerts = createAction('RESET_ALERTS')

// Alerts Dashboard
export const setAlertsForDashboard = createAction(
  'SET_DATA_FOR_ALERTS_DASHBOARD'
)

export const setAlertsByCaseManagers = createAction(
  'SET_ALERTS_BY_CASE_MANAGERS_FOR_ALERTS_DASHBOARD'
)

export const setAlertsByFacilities = createAction(
  'SET_ALERTS_BY_FACILITIES_FOR_ALERTS_DASHBOARD'
)
